import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { IconButton, InputAdornment, TextField, Typography } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import DeleteIcon from '@material-ui/icons/DeleteOutline'
import useStyles from './SelectTextField.styles'
import { corPorCategoria } from 'utils/helpers'

const verificarValorOutro = (valores, prop, isObjeto, multiple) => {
  const valor = valores?.[prop]
  if (!valor) return false

  if (isObjeto) {
    if (multiple && Array.isArray(valor)) {
      return valor.some((value) => value?.nome?.toUpperCase() === 'OUTRO')
    }
    return valor.nome?.toUpperCase() === 'OUTRO'
  } else {
    if (multiple && Array.isArray(valor)) {
      return valor.some((value) => value?.toUpperCase() === 'OUTRO')
    }
    return valor.toUpperCase() === 'OUTRO'
  }
}

const getLabel = (option) => {
  if (!option) return ''
  if (typeof option === 'string') {
    return option
  }
  if (typeof option === 'object' && !Array.isArray(option)) {
    return option.nome || ''
  }
  return ''
}

export const SelectTextField = React.memo((props) => {
  const { form, prop, label, propInput, labelInput, options, multiple, isValoresObjeto, required } = props
  const classes = useStyles()

  const isOutro = useMemo(() => {
    return verificarValorOutro(form.formState.values, prop, isValoresObjeto, multiple)
  }, [form.formState.values, prop, isValoresObjeto, multiple])

  return (
    <div>
      {isOutro && (
        <TextField
          label={labelInput}
          name={propInput}
          required={required}
          variant="outlined"
          value={form.formState.values[propInput] || ''}
          onChange={form.handleChange}
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">
                <IconButton
                  onClick={() => {
                    form.setFormState((prevState) => ({ ...prevState, values: { ...prevState.values, [prop]: null } }))
                    form.setFormState((prevState) => ({ ...prevState, values: { ...prevState.values, [propInput]: null } }))
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      )}

      {!isOutro && (
        <Autocomplete
          value={form.formState.values[prop] || (multiple ? [] : null)}
          name={prop}
          noOptionsText="Sem informações"
          multiple={multiple}
          options={options}
          onChange={(event, newValue) => {
            form.handleChangeNewValueByNameProperty(event, newValue, prop)
          }}
          getOptionSelected={(option, value) => (isValoresObjeto ? option.id === value?.id : option === value)}
          filterSelectedOptions
          getOptionLabel={getLabel}
          renderOption={(option) => {
            const customColor = isValoresObjeto && option.categoria ? corPorCategoria(option.categoria) : undefined
            return (
              <Typography className={classes.optionText} style={customColor ? { color: customColor } : undefined}>
                {isValoresObjeto ? option?.nome : option || ''}
              </Typography>
            )
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              required={required}
              variant="outlined"
              placeholder={form.formState.values[prop]?.length || 'Selecionar...'}
              label={label}
              InputLabelProps={{
                shrink: true,
              }}
              error={form.hasError(prop)}
              helperText={form.hasError(prop) ? form.formState.errors[prop]?.[0] : null}
            />
          )}
        />
      )}
    </div>
  )
})

SelectTextField.propTypes = {
  form: PropTypes.object.isRequired,
  prop: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  propInput: PropTypes.string,
  labelInput: PropTypes.string,
  options: PropTypes.array.isRequired,
  multiple: PropTypes.bool,
  isValoresObjeto: PropTypes.bool,
  required: PropTypes.bool,
}

SelectTextField.displayName = 'SelectTextField'
